import React from 'react';

import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import { HeaderText, SecondaryText } from 'apps/auth/components/common/Layout/InfoPage/styles';
import { MainColumn } from 'apps/auth/components/common/Layout/MainColumn/MainColumn';
import { IntroBlock, IntroBlockImg } from 'apps/auth/components/common/Layout/MainColumn/styles';
import Notification from 'apps/auth/components/history/Notification';
import { URL_IMAGES_I } from 'apps/auth/constants/UrlConstants';
import { usePageMessages } from 'apps/auth/hooks/selectors';
import { useThemeDetector } from 'apps/auth/hooks/theme';

const EmptyCardsLibre = () => {
    const { libreEmptyCardTitle, libreEmptyCardText } = usePageMessages();

    const { theme } = useThemeDetector();

    return (
        <MainColumn>
            <Notification />
            <IntroBlock>
                <IntroBlockImg>
                    <img src={`${URL_IMAGES_I}/empty-card-mastercard-libre${theme === 'dark' ? '-dark' : '-light'}.svg`} alt="empty-card-mastercard-libre" />
                </IntroBlockImg>
                <HeaderText>{libreEmptyCardTitle}</HeaderText>
                <SecondaryText>
                    <DangerouslyHtml dangerouslyHtml={libreEmptyCardText} />
                </SecondaryText>
            </IntroBlock>
        </MainColumn>
    );
};

export default EmptyCardsLibre;
